import Sortable from '@stimulus-components/sortable'

export default Sortable
